module.exports = __webpack_public_path__ + "media/images/admin/icons/link-0e17f72a57b2fea8084fe0c43ce51959.svg";